import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const FeatureFlagSchema = withDefaults({
  type: 'feature-flag',
  fields: [
    { kind: 'attribute', name: 'key' },
    { kind: 'attribute', name: 'description' },
    { kind: 'attribute', name: 'link' },
    { kind: 'attribute', name: 'project' },
    { kind: 'attribute', name: 'readBy' },
    { kind: 'attribute', name: 'readByInferred' },
    { kind: 'attribute', name: 'webApps' },
    { kind: 'attribute', name: 'defaultInCode' },
    { kind: 'attribute', name: 'exposeToWeb' },
    { kind: 'attribute', name: 'environments' },
    { kind: 'attribute', name: 'createdBy' },
    { kind: 'attribute', name: 'updatedBy' },
    { kind: 'attribute', name: 'updateTime' },
    { kind: 'attribute', name: 'retiredAt' },
    { kind: 'attribute', name: 'retiredBy' },
    { kind: 'attribute', name: 'retiredReason' },
    { kind: 'attribute', name: 'lifecycle' },
  ],
});

export default FeatureFlagSchema;
